<div ngSkipHydration>

<!-- 📊 CONTENEDOR DE LA TABLA PRINCIPAL -->
<div class="container-fluid px-4">
  
  <!-- ENCABEZADO OPTIMIZADO CON BOTONERA DUAL SAAS CORE -->
  <div class="d-flex justify-content-between align-items-center mb-3">
    <div>
      <h2 class="h5 m-0 fw-bold text-dark text-uppercase" style="letter-spacing: 0.5px;">Matriz de Usuarios y Seguridad Perimetral</h2>
    </div>
    
    <div class="d-flex gap-2">
      <!-- Botón 1: Llama al nuevo modal de Personal F0101 -->
      <button type="button" class="btn btn-outline-primary btn-sm px-3 fw-bold shadow-sm d-flex align-items-center gap-1" 
              (click)="abrirPersonalModal()" style="border-radius: 6px;">
        ➕ Registrar Personal F0101
      </button>
      
      <!-- Botón 2: Llama a tu método existente de Usuarios -->
      <button type="button" class="btn btn-primary btn-sm px-3 fw-bold shadow-sm d-flex align-items-center gap-1" 
              (click)="abrirAltaModal()" style="border-radius: 6px;">
        👤 Crear Nuevo Usuario
      </button>
    </div>
  </div>

  <!-- Contenedor del Buscador y Selectores (Se mantiene intacto) -->
  <div class="card mb-3 border-0 shadow-sm bg-light">
    <div class="card-body p-2">
      <div class="row g-2">
        <!-- Caja de Texto Libre -->
        <div class="col-md-7">
          <div class="form-floating input-group input-group-sm">
            <span class="input-group-text bg-white border-end-0">🔍</span>
            <input type="text" class="form-control border-start-0 ps-0 text-uppercase" id="busquedaUser" 
                  [(ngModel)]="filtroUserTexto" (input)="filtrarUsuarios()" placeholder="Buscar por Login ID o Nombre Completo...">
          </div>
        </div>
        
        <!-- Selector por Rol de la UDC -->
        <div class="col-md-5">
          <select class="form-select form-select-sm h-100 fw-bold text-secondary" [(ngModel)]="filtroUserRol" (change)="filtrarUsuarios()">
            <option value="">-- Todos los Roles Autorizados --</option>
            <option value="ROLE_ADMIN">ROLE_ADMIN (Administración)</option>
            <option value="ROLE_ASESOR">ROLE_ASESOR (Asesores Comerciales)</option>
            <option value="ROLE_MECHANIC">ROLE_MECHANIC (Técnicos Especialistas)</option>
          </select>
        </div>
      </div>
    </div>
  </div>

  <!-- Rejilla Principal de Cuentas (Se mantiene intacta) -->
  <table class="table table-hover table-striped border shadow-sm align-middle">
    <thead class="table-dark">
      <tr>
        <th scope="col" style="width: 150px;">LOGIN ID</th>
        <th scope="col" style="width: 140px;">CÓDIGO AN8</th>
        <th scope="col">NOMBRE COMPLETO (F0101)</th>
        <th scope="col">ROLE ASIGNADO</th>
        <th scope="col" class="text-center" style="width: 140px;">ESTATUS CUENTA</th>
        <th scope="col" class="text-center" style="width: 160px;">ACCIONES</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let u of usersPaginados; trackBy: trackByUserId">
        <th scope="row" class="font-monospace text-primary fw-bold">{{ u.userId }}</th>
        <td class="font-monospace text-secondary fw-semibold">{{ u.an8 }}</td>
        <td class="fw-semibold text-dark text-uppercase">{{ u.nameAlpha }}</td>

        <td>
          <span class="badge bg-light text-dark me-1 border text-uppercase">
            {{ u.rolesNombres?.join(', ') || 'SIN ROL ASIGNADO' }}
          </span>
        </td>
        
        <td class="text-center">
          <span class="badge rounded-pill px-3 py-1 font-monospace"
                [ngClass]="u.enabled ? 'bg-success-subtle text-success border border-success' : 'bg-danger-subtle text-danger border border-danger'">
            {{ u.enabled ? 'HABILITADO' : 'INACTIVO' }}
          </span>
        </td>
        
        <td class="text-center">
          <button type="button" class="btn btn-info btn-sm text-white px-3 fw-bold shadow-sm d-inline-flex align-items-center gap-1"
                  style="border-radius: 6px; font-size: 0.8rem;"
                  (click)="editUser(u)">
            🔑 Ajustar Privilegios
          </button>
        </td>
      </tr>
      
      <tr *ngIf="usersFiltrados.length === 0">
        <td colspan="6" class="text-center text-muted py-4">
          ⚠️ No se encontraron perfiles de usuario que coincidan con los criterios de búsqueda.
        </td>
      </tr>
    </tbody>
  </table>

  <!-- Botonera de Paginación y Contador (Se mantiene intacta) -->
  <div class="d-flex justify-content-between align-items-center mt-3 border-top pt-2">
    <nav aria-label="Navegación de usuarios">
      <ul class="pagination pagination-sm m-0 shadow-sm" style="border-radius: 6px; overflow: hidden; font-size: 0.82rem;">
        <li class="page-item" [class.disabled]="paginaActual === 1">
          <button type="button" class="page-link fw-bold text-dark border px-2.5" 
                  (click)="cambiarPagina(1)" style="cursor: pointer;" title="Ir a la primera página">
            ⏮️ Primera
          </button>
        </li>
        <li class="page-item" [class.disabled]="paginaActual === 1">
          <button type="button" class="page-link fw-bold text-dark border" (click)="cambiarPagina(paginaActual - 1)" style="cursor: pointer;">
            ◀️ Anterior
          </button>
        </li>
        <li class="page-item disabled">
          <span class="page-link bg-light text-dark font-monospace border fw-bold px-3">
            PÁGINA {{ paginaActual }} DE {{ totalPaginas }}
          </span>
        </li>
        <li class="page-item" [class.disabled]="paginaActual === totalPaginas">
          <button type="button" class="page-link fw-bold text-dark border" (click)="cambiarPagina(paginaActual + 1)" style="cursor: pointer;">
            Siguiente ▶️
          </button>
        </li>
        <li class="page-item" [class.disabled]="paginaActual === totalPaginas">
          <button type="button" class="page-link fw-bold text-dark border px-2.5" 
                  (click)="cambiarPagina(totalPaginas)" style="cursor: pointer;" title="Ir a la última página">
            Última ⏭️
          </button>
        </li>
      </ul>
    </nav>

    <span class="text-muted small text-end">
      Mostrando usuarios del <strong>{{ usersFiltrados.length === 0 ? 0 : ((paginaActual - 1) * registrosPorPagina) + 1 }}</strong> 
      al <strong>{{ Math.min(paginaActual * registrosPorPagina, usersFiltrados.length) }}</strong> 
      de un total de <strong>{{ usersFiltrados.length }}</strong> cuentas indexadas en red.
    </span>
  </div>

</div> <!-- Cierre container-fluid -->

<!-- Contenedor Flotante de Toasts (Se mantiene intacto) -->
<div class="toast-container position-fixed top-0 end-0 p-3" style="z-index: 1080; margin-top: 50px;">
  <div *ngFor="let toast of toastService.toasts" 
       class="toast show shadow border-0 mb-2" 
       [ngClass]="'bg-' + toast.type + '-subtle text-dark'"
       role="alert" aria-live="assertive" aria-atomic="true">
    <div class="toast-header border-0 bg-transparent text-dark d-flex justify-content-between align-items-center">
      <strong class="me-auto d-flex align-items-center gap-2">
        <span>{{ toast.type === 'danger' ? '⚠️' : '✅' }}</span>
        {{ toast.title }}
      </strong>
      <button type="button" class="btn-close" (click)="toastService.remove(toast)"></button>
    </div>
    <div class="toast-body pt-0" style="font-size: 0.85rem;">
      {{ toast.text }}
    </div>
  </div>
</div>

</div> <!-- Cierre ngSkipHydration -->